import React from 'react';
import { Page } from '../../../../../shared/Components/Page';
import {ValidacionesContainer} from './Screen';

export const ValidacionDNView = () =>{

    return (
        <Page title={'Validación'} scrollBody>{<ValidacionesContainer/>}</Page>
    )
}